var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat"},[_c('div',{staticClass:"stat-metric"},[_vm._v(_vm._s(_vm.metric))]),_c('div',{staticClass:"stat-value"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }